import React, { useEffect, useState } from "react";
// import FormGroup from "app/Components/Form/FormGroup.component";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";
import InputError from "app/Components/_form/InputError/InputError";
import { Col, Row, FormGroup } from "react-bootstrap";
import {
  employeeFormLabel,
  employeeMedicalCategoryList,
  employeeMedicalEligibilityList,
  generatedTypeObj,
} from "../Constant";
import Label from "app/Components/_form/Label/Label";
import YesOrNo from "app/_pages/_healthSafetyEnvironment/YesOrNo.component";
import DatePicker from "app/Components/DateTimeCustom/CustomDateTime";
import { disableFutureDate } from "app/_helpers/dateHelper";
import FormInput from "app/Components/_form/FormInput/FormInput";
import SingleFileUpload from "app/views/custom/components/FileUpload/SingleFileUpload";
import { checkCurrentMedicalInprogress } from "app/_services/UserManagement/EmployeeService";
import toastr from "toastr";

function InitialMedicalForm({
  form = {},
  onChange,
  error = {},
  id,
  lgClass,
  menuPortalTarget,
  showMedical,
  isDisable,
  employeeType,
}) {
  const [certificateFile, setCertificateFile] = useState(
    () => form?.certificateFile || {}
  );
  const [imeMedicalInprogress, setImeMedicalInprogress] = useState(false);
  const [pmeMedicalInprogress, setPmeMedicalInprogress] = useState(false);
  let isPmeManual = !form?.pmeManual && form?.pmeUpdatedBy === generatedTypeObj.manual;
  let isImeManual = form?.imeUpdatedBy === generatedTypeObj.manual;
  let imeDateLabel = id
    ? `${employeeFormLabel["imeDate"]} ${
        isImeManual ? " ( Manual entered )" : " ( System genetated )"
      }`
    : employeeFormLabel["imeDate"];

  let pmeDateLabel = id
    ? `${employeeFormLabel["pmeDate"]} ${
        isPmeManual ? " ( Manual entered )" : " ( System genetated )"
      }`
    : employeeFormLabel["pmeDate"];

  const onFileChange = (event, responseData, name) => {
    onChange({
      target: {
        name: name,
        value: responseData?.id,
      },
    });
    setCertificateFile((prev) => ({
      ...prev,
      [name]: responseData,
    }));
  };
  const deleteDocumentFile = (_event, name) => {
    onChange({
      target: {
        name: name,
        value: null,
      },
    });
    setCertificateFile((prev) => ({
      ...prev,
      [name]: null,
    }));
  };

  useEffect(() => {
    if (!id) return;
    (async () => {
      const response = await checkCurrentMedicalInprogress(
        id,
        `employeeType=${employeeType}&medicalTestType=ime`
      );
      if (response?.status) {
        setImeMedicalInprogress(true);
      }

      const response1 = await checkCurrentMedicalInprogress(
        id,
        `employeeType=${employeeType}&medicalTestType=pme`
      );
      if (response1?.status) {
        setPmeMedicalInprogress(true);
      }
    })();
  }, [employeeType, id]);

  const onChangeHandle = (e, medicalTestType) => {
    if (imeMedicalInprogress && medicalTestType === "ime") {
      toastr.error("Current IME medical in-progress");
    } else if (pmeMedicalInprogress && medicalTestType === "pme") {
      toastr.error("Current PME medical in-progress");
    } else {
      onChange(e);
    }
  };

  return (
    (isImeManual || isPmeManual || !id) && (
      <div className="mt-2">
        <h5 className="highlightTxt">Previous Medical Record</h5>
        {showMedical && (
          <>
            <Row className="justify-content-start align-items-center">
              <Col lg={lgClass ? lgClass : 4} className={"mt-4 mb-4"}>
                <YesOrNo
                  title={employeeFormLabel["isIMEDate"]}
                  name="isIMEDate"
                  value={form.isIMEDate === null ? false : form.isIMEDate}
                  onChange={(e) => onChangeHandle(e, "ime")}
                  disabled={isImeManual || !id ? false : true}
                />
                <span className="small text-danger">{error?.isIMEDate}</span>
              </Col>
            </Row>

            {form.isIMEDate === true && (
              <Row className="justify-content-start align-items-center">
                <Col md={4}>
                  <FormGroup>
                    <Label>{imeDateLabel}</Label>

                    <DatePicker
                      name={"imeDate"}
                      value={form.imeDate}
                      onChangeDate={(e) => onChangeHandle(e, "ime")}
                      label={employeeFormLabel["imeDate"]}
                      placeHolder={employeeFormLabel["imeDate"]}
                      error={error["imeDate"]}
                      disabled={isImeManual || !id ? false : true}
                      isValidDate={disableFutureDate}
                    />
                    <InputError error={error["imeDate"]} />
                  </FormGroup>
                </Col>

                <Col md={4}>
                  <FormInput
                    name={"imeCertificateNo"}
                    type="text"
                    value={form.imeCertificateNo}
                    onChange={onChange}
                    label={employeeFormLabel["imeCertificateNo"]}
                    placeHolder={employeeFormLabel["imeCertificateNo"]}
                    error={error["imeCertificateNo"]}
                    disabled={isImeManual || !id ? false : true}
                  />
                </Col>

                {isImeManual || !id ? (
                  <Col md={4}>
                    <div className="form-group viewbox">
                      <label>{employeeFormLabel["imeCertificateId"]}</label>
                      <SingleFileUpload
                        clsName="form-group"
                        alias={false}
                        name="imeCertificateId"
                        disabled={isImeManual || !id ? false : true}
                        labelName=" "
                        selectedFile={
                          form?.imeCertificateId
                            ? certificateFile?.imeCertificateId
                            : null
                        }
                        deleteDocumentFile={deleteDocumentFile}
                        onFileChange={onFileChange}
                      />
                      {/* <span className="small text-danger">{errorForm.completionProofId}</span> */}
                    </div>
                  </Col>
                ) : (
                  ""
                )}
              </Row>
            )}

            <Row className="justify-content-start align-items-center">
              <Col lg={lgClass ? lgClass : 4} className={"mt-4 mb-4"}>
                <YesOrNo
                  title="Is Last PME Date Available?"
                  name="isPmeDate"
                  value={form.isPmeDate === null ? false : form.isPmeDate}
                  onChange={(e) => onChangeHandle(e, "pme")}
                  disabled={isPmeManual || !id ? false : true}
                />
                <span className="small text-danger">{error?.isPmeDate}</span>
              </Col>
            </Row>

            {form.isPmeDate === true && (
              <Row className="mb-2 justify-content-start align-items-center">
                <Col md={4}>
                  <FormGroup>
                    <Label>{pmeDateLabel}</Label>

                    <DatePicker
                      name={"pmeDate"}
                      value={form.pmeDate}
                      onChangeDate={(e) => onChangeHandle(e, "pme")}
                      label={employeeFormLabel["pmeDate"]}
                      placeHolder={employeeFormLabel["pmeDate"]}
                      error={error["pmeDate"]}
                      disabled={isPmeManual || !id ? false : true}
                      isValidDate={disableFutureDate}
                    />
                    <InputError error={error["pmeDate"]} />
                  </FormGroup>
                </Col>

                <Col md={4}>
                  <FormInput
                    name={"pmeCertificateNo"}
                    type="text"
                    value={form.pmeCertificateNo}
                    onChange={onChange}
                    label={employeeFormLabel["pmeCertificateNo"]}
                    placeHolder={employeeFormLabel["pmeCertificateNo"]}
                    error={error["pmeCertificateNo"]}
                    disabled={isPmeManual || !id ? false : true}
                  />
                </Col>

                {isPmeManual || !id ? (
                  <Col md={4}>
                    <div className="form-group viewbox">
                      <label>{employeeFormLabel["pmeCertificateId"]}</label>
                      <SingleFileUpload
                        clsName="form-group"
                        alias={false}
                        name="pmeCertificateId"
                        disabled={isPmeManual || !id ? false : true}
                        labelName=" "
                        selectedFile={
                          form?.pmeCertificateId
                            ? certificateFile?.pmeCertificateId
                            : null
                        }
                        deleteDocumentFile={deleteDocumentFile}
                        onFileChange={onFileChange}
                      />
                      {/* <span className="small text-danger">{errorForm.completionProofId}</span> */}
                    </div>
                  </Col>
                ) : (
                  ""
                )}
              </Row>
            )}
          </>
        )}

        {!id && (
          <Row className="mb-4 justify-content-start align-items-center">
            <Col md={4}>
              <FormGroup>
                <Label>{employeeFormLabel["specialMedicalExamEligibility"]}</Label>

                <SimpleSelect
                  name={"specialMedicalExamEligibility"}
                  value={form.specialMedicalExamEligibility}
                  onChange={onChange}
                  options={employeeMedicalEligibilityList}
                  placeHolder={employeeFormLabel["specialMedicalExamEligibility"]}
                  label={"name"}
                  id="value"
                  menuPortalTarget={menuPortalTarget}
                  disabled={isDisable ? isDisable : false}
                />
                <InputError error={error["specialMedicalExamEligibility"]} />
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label>{employeeFormLabel["specialMedicalExamCategory"]}</Label>

                <SimpleSelect
                  name={"specialMedicalExamCategory"}
                  value={form.specialMedicalExamCategory}
                  onChange={onChange}
                  options={employeeMedicalCategoryList}
                  label={"name"}
                  id="value"
                  placeHolder={employeeFormLabel["specialMedicalExamCategory"]}
                  disabled={
                    form.specialMedicalExamEligibility !== "yes"
                      ? true
                      : isDisable
                      ? isDisable
                      : false
                  }
                  menuPortalTarget={menuPortalTarget}
                />
                <InputError error={error["specialMedicalExamCategory"]} />
              </FormGroup>
            </Col>
          </Row>
        )}
      </div>
    )
  );
}

const MedicalForm = ({ form, onChange, error }) => (
  <>
    <Row className="mb-4 justify-content-start align-items-center">
      <Col md={4}>
        <FormGroup>
          <Label>{employeeFormLabel["specialMedicalExamCategory"]}</Label>

          <SimpleSelect
            name={"specialMedicalExamCategory"}
            value={form.specialMedicalExamCategory}
            onChange={onChange}
            options={employeeMedicalCategoryList}
            label={"name"}
            id="value"
            placeHolder={employeeFormLabel["specialMedicalExamCategory"]}
            // disabled={!form.specialMedicalExamEligibility}
          />
          <InputError error={error["specialMedicalExamCategory"]} />
        </FormGroup>
      </Col>
      <Col md={4}>
        <FormGroup>
          <Label>{employeeFormLabel["specialMedicalExamEligibility"]}</Label>

          <SimpleSelect
            name={"specialMedicalExamEligibility"}
            value={form.specialMedicalExamEligibility}
            onChange={onChange}
            options={employeeMedicalEligibilityList}
            placeHolder={employeeFormLabel["specialMedicalExamEligibility"]}
            label={"name"}
            id="value"
          />
          <InputError error={error["specialMedicalExamEligibility"]} />
        </FormGroup>
      </Col>
    </Row>
  </>
);

export default InitialMedicalForm;
